import React from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { Box } from '@rbilabs/components-library/build/components/layout';

import { ActionButtonVariants } from 'components/action-button';
import { CustomEventNames, EventTypes } from 'state/mParticle/constants';

import { StyledRedemptionButton } from './redemption-button.styled';
import { IRedemptionButton } from './types';

export const RedemptionButton: React.FC<IRedemptionButton> = ({
  onClickRestaurantRedemption,
  restaurantRedemptionButtonTitle,
  disabled,
  isDesktop,
}) => {
  return (
    <Box margin={isDesktop ? '1.2rem 0 0' : '1rem 0 0'}>
      <StyledRedemptionButton
        data-testid="restaurant-redemption-button"
        onClick={onClickRestaurantRedemption}
        eventName={CustomEventNames.OFFER_CODE_REQUESTED}
        eventType={EventTypes.Other}
        disabled={disabled}
        startIcon={<Icon icon={'storeTwo'} color={'primary'} width="20px" aria-hidden />}
        variant={ActionButtonVariants.OUTLINE}
      >
        {restaurantRedemptionButtonTitle}
      </StyledRedemptionButton>
    </Box>
  );
};
